import * as Sentry from "@sentry/react";

export const exhaustivenessCheck = (value: never) => {
  Sentry.captureException(
    `This should never happen. Implementation error. Value = ${JSON.stringify(
      value,
    )}`,
  );
};
